import React from 'react';
import { PriceDisplay } from './PriceDisplay';
import { motion } from 'framer-motion';
export function BonusSection() {
  return <motion.section initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5
  }} className="py-20 px-4 bg-[#110e05] border-y border-brand-gold/30" data-id="element-10">
      <div className="max-w-4xl mx-auto" data-id="element-11">
        <div className="text-center mb-16" data-id="element-12">
          <h2 className="text-4xl md:text-5xl font-heading text-brand-gold uppercase" data-id="element-13">
            🎁 BONUS EXCLUSIVOS (SOLO HOY)
          </h2>
        </div>

        <div className="space-y-8" data-id="element-14">
          <div className="bg-gray-900 border border-brand-gold/50 p-8 rounded-2xl relative overflow-hidden shadow-[0_0_20px_rgba(245,158,11,0.1)]" data-id="element-15">
            <div className="absolute top-0 right-0 bg-brand-gold text-black font-bold px-6 py-2 rounded-bl-xl text-sm tracking-widest" data-id="element-16">
              BONUS 1
            </div>
            <div className="flex flex-col md:flex-row gap-6 items-center" data-id="element-17">
              <div className="w-full md:w-48 flex-shrink-0" data-id="element-18">
                <img src="https://cdn.magicpatterns.com/uploads/hUxRqneLjvxePNyiBNatwK/Protocolo_para_Usar_Hoy_Mismo.png" alt="Protocolo para Usar Hoy Mismo" className="w-full rounded-xl shadow-lg" data-id="element-19" />
              </div>
              <div className="flex-1" data-id="element-20">
                <h3 className="text-2xl font-bold text-white mb-3 pr-24 leading-snug" data-id="element-21">
                  PROTOCOLO PARA USAR HOY MISMO: RENDÍ AL MÁXIMO ESTA NOCHE
                </h3>
                <p className="text-gray-400 mb-6 text-lg" data-id="element-22">
                  Técnicas que podés aplicar esta misma noche para rendir al
                  máximo.
                </p>
                <div className="flex items-center text-xl" data-id="element-23">
                  <span className="text-gray-500 line-through mr-4" data-id="element-24">
                    Valor: $19.990
                  </span>
                  <span className="text-brand-green font-bold" data-id="element-25">→ GRATIS</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gray-900 border border-brand-gold/50 p-8 rounded-2xl relative overflow-hidden shadow-[0_0_20px_rgba(245,158,11,0.1)]" data-id="element-26">
            <div className="absolute top-0 right-0 bg-brand-gold text-black font-bold px-6 py-2 rounded-bl-xl text-sm tracking-widest" data-id="element-27">
              BONUS 2
            </div>
            <div className="flex flex-col md:flex-row gap-6 items-center" data-id="element-28">
              <div className="w-full md:w-48 flex-shrink-0" data-id="element-29">
                <img src="https://cdn.magicpatterns.com/uploads/pckGECYXxtQkSsDSL1FCfW/Volvete_Inolvidable_sin_Importar_el_Tiempo.png" alt="Volvete Inolvidable sin Importar el Tiempo" className="w-full rounded-xl shadow-lg" data-id="element-30" />
              </div>
              <div className="flex-1" data-id="element-31">
                <h3 className="text-2xl font-bold text-white mb-3 pr-24 leading-snug" data-id="element-32">
                  VOLVETE INOLVIDABLE SIN IMPORTAR EL TIEMPO: LA GUÍA PARA DAR
                  PLACER Y SIN APURO
                </h3>
                <p className="text-gray-400 mb-6 text-lg" data-id="element-33">
                  Aprendé a dar placer sin depender del tiempo. Ella no va a
                  olvidarte.
                </p>
                <div className="flex items-center text-xl" data-id="element-34">
                  <span className="text-gray-500 line-through mr-4" data-id="element-35">
                    Valor: $15.800
                  </span>
                  <span className="text-brand-green font-bold" data-id="element-36">→ GRATIS</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gray-900 border border-brand-gold/50 p-8 rounded-2xl relative overflow-hidden shadow-[0_0_20px_rgba(245,158,11,0.1)]" data-id="element-37">
            <div className="absolute top-0 right-0 bg-brand-gold text-black font-bold px-6 py-2 rounded-bl-xl text-sm tracking-widest" data-id="element-38">
              BONUS 3
            </div>
            <div className="flex flex-col md:flex-row gap-6 items-center" data-id="element-39">
              <div className="w-full md:w-48 flex-shrink-0" data-id="element-40">
                <img src="https://cdn.magicpatterns.com/uploads/7BGpqhSgERD6TVkQD7Q2iw/Control_Total_en_14_Dias.png" alt="Control Total en 14 Días" className="w-full rounded-xl shadow-lg" data-id="element-41" />
              </div>
              <div className="flex-1" data-id="element-42">
                <h3 className="text-2xl font-bold text-white mb-3 pr-24 leading-snug" data-id="element-43">
                  CONTROL TOTAL EN 14 DÍAS: EL METODO PARA MULTIPLICAR EL
                  AGUANTE
                </h3>
                <p className="text-gray-400 mb-6 text-lg" data-id="element-44">
                  El plan de 14 días para multiplicar tu aguante de forma
                  progresiva.
                </p>
                <div className="flex items-center text-xl" data-id="element-45">
                  <span className="text-gray-500 line-through mr-4" data-id="element-46">
                    Valor: $49.900
                  </span>
                  <span className="text-brand-green font-bold" data-id="element-47">→ GRATIS</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 bg-brand-gold/10 border-2 border-brand-gold p-10 rounded-2xl text-center" data-id="element-48">
          <p className="text-2xl text-gray-300 mb-3 font-medium" data-id="element-49">
            💰 VALOR TOTAL:
          </p>
          <p className="text-4xl text-gray-500 line-through mb-6 font-bold" data-id="element-50">
            $85.690
          </p>
          <div className="text-4xl md:text-5xl font-bold text-white" data-id="element-51">
            🔥 HOY SOLO:{' '}
            <span className="text-brand-green ml-3" data-id="element-52">
              <PriceDisplay amount={19990} data-id="element-53" />
            </span>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-center space-y-3" data-id="element-54">
          <a href="[CART_LINK]" className="inline-block w-full md:w-auto text-center bg-brand-red hover:bg-brand-redHover text-white font-heading text-2xl py-5 px-12 rounded-xl transition-all transform hover:scale-[1.02] shadow-[0_0_25px_rgba(220,38,38,0.3)]" data-id="element-55">
            ACCEDER A TODO AHORA →
          </a>
          <p className="text-sm text-gray-400 font-medium" data-id="element-56">
            ⚡ Acceso inmediato a todo el sistema + bonos
          </p>
        </div>
      </div>
    </motion.section>;
}